import styled from 'styled-components';
import { InfoCircleOutlined, FilterOutlined, CheckCircleFilled, ArrowRightOutlined, QuestionCircleOutlined } from '@ant-design/icons';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.cardBg ?? theme.colors.white};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight ?? '#E5E7EB'};
  box-shadow: 0 2px 12px rgba(16, 24, 64, 0.08);
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
  flex-shrink: 0;
  z-index: 10;
  position: relative;
  background: ${({ theme }) => theme.colors.cardBg ?? theme.colors.white};
`;

export const HeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0;
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  .ant-tabs { flex: 1; min-width: 0; }
  .ant-tabs-nav { margin-bottom: 0 !important; }
  .ant-tabs-nav::before { border-bottom: none !important; }
  .ant-tabs-tab { padding-top: 4px !important; }
  .ant-tabs-tab .ant-tabs-tab-btn { font-size: 14px; font-weight: 500; }
`;

export const SubtitleArrow = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
  margin: 0 3px;
`;

export const PageTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const BulkToolbarRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
`;

export const MappingActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0 12px;
  flex-shrink: 0;
`;

export const MappingActionsGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const MappingConfirmedText = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.statusCompleted};
`;

export const PremiumButtonWrapper = styled.div`
  display: inline-flex;

  .ant-btn {
    border-radius: 10px !important;
    font-weight: 600 !important;
    padding: 6px 20px !important;
    height: auto !important;
    font-size: 13px !important;
  }
`;

export const OnboardResultBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin: 0 0 12px;
  padding: 10px 14px;
  border-radius: 8px;
  background: ${({ $variant, theme }) =>
    $variant === 'error'
      ? (theme?.colors?.errorBg ?? '#FEF2F2')
      : (theme?.colors?.warningBg ?? '#FFFBEB')};
  border: 1px solid ${({ $variant, theme }) =>
    $variant === 'error'
      ? (theme?.colors?.errorBorder ?? '#FECACA')
      : (theme?.colors?.warningBorder ?? '#FFB020')};
`;

export const OnboardResultIcon = styled.span`
  display: flex;
  align-items: center;
  margin-top: 1px;
  font-size: 15px;
  flex-shrink: 0;
  color: ${({ $variant, theme }) =>
    $variant === 'error'
      ? (theme?.colors?.error ?? '#DC2626')
      : (theme?.colors?.warningBorder ?? '#B45309')};
`;

export const OnboardResultBody = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 12.5px;
  font-weight: 500;
  line-height: 1.5;
  word-break: break-word;
  color: ${({ $variant, theme }) =>
    $variant === 'error'
      ? (theme?.colors?.error ?? '#B91C1C')
      : (theme?.colors?.warningMessage ?? '#996A13')};
`;

export const OnboardResultActions = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 1px;
`;

export const ContentSection = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  position: relative;
  z-index: 1;
`;


export const MappingTabBar = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  background: ${({ theme }) => theme.colors.light};
  border-radius: 8px;
  padding: 3px;
`;

export const MappingTabBtn = styled.button`
  padding: 4px 14px;
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  border-radius: 6px;
  border: none;
  cursor: pointer;
  background: ${({ $active, $resolved, theme }) =>
    $resolved && $active ? theme.colors.successBg :
    $active ? theme.colors.white : 'transparent'};
  color: ${({ $active, $resolved, theme }) =>
    $resolved ? theme.colors.statusCompleted :
    $active ? theme.colors.primary : theme.colors.tertiary};
  box-shadow: ${({ $active }) => ($active ? '0 1px 3px rgba(0,0,0,0.10)' : 'none')};
  transition: color 0.15s, background 0.15s, box-shadow 0.15s;
  white-space: nowrap;

  &:hover {
    color: ${({ $resolved, theme }) => ($resolved ? theme.colors.statusCompleted : theme.colors.primary)};
  }
`;

export const ReqIdLink = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;

  &:hover {
    text-decoration: underline;
  }
`;

export const IssueText = styled.span`
  color: ${({ theme }) => theme.colors.warningMessage};
  font-size: 12px;
`;

export const ReqMetaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 200px;
  padding: 4px 0;
`;

export const ReqMetaItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const ReqMetaLabel = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.tertiary};
  min-width: 90px;
  flex-shrink: 0;
`;

export const ReqMetaValue = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dark};
`;

export const ResolveSelectWrapper = styled.div`
  width: 200px;
`;

export const SkippedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.tertiary};
  font-style: italic;
`;

export const ReqPickerTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 6px;
  border: 1.5px ${({ $selected }) => ($selected ? 'solid' : 'dashed')} ${({ theme }) => theme.colors.primary};
  background: ${({ $selected, theme }) => ($selected ? theme.colors.secondary : 'transparent')};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  font-weight: ${({ $selected }) => ($selected ? 600 : 500)};
  cursor: pointer;
  max-width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.secondary};
  }
`;

export const ReqPickerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 260px;
  max-width: 320px;
`;

export const ReqPickerCard = styled.div`
  padding: 8px 12px;
  border-radius: 6px;
  border: 1.5px solid ${({ $selected, theme }) => ($selected ? theme.colors.primary : theme.colors.borderLight)};
  background: ${({ $selected, theme }) => ($selected ? theme.colors.secondary : theme.colors.white)};
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.secondary};
  }
`;

export const ReqPickerCardTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.4;
`;

export const ReqPickerCardMeta = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.tertiary};
  line-height: 1.3;
  margin-top: 2px;
`;

export const PreviewToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  flex-shrink: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
  margin-bottom: 16px;
`;

export const PreviewToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PreviewToolbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PreviewMeta = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.tertiary};
`;

export const TableWrapper = styled.div`
  flex: 1;
  overflow: auto;

  .ant-table-pagination {
    position: sticky;
    bottom: 0;
    background: ${({ theme }) => theme.colors.white};
    padding: 10px 0;
    margin: 0 !important;
    border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
  }
`;

export const EmptyStateWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
`;

export const ReadyStateWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ReadyCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 36px 48px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.successBorder};
  background: ${({ theme }) => theme.colors.successBg};
  text-align: center;
  max-width: 400px;
  width: 100%;
`;

export const ReadyIcon = styled.span`
  font-size: 28px;
  color: ${({ theme }) => theme.colors.statusCompleted};
  margin-bottom: 4px;
`;

export const ReadyFileName = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const ReadyText = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.tertiary};
  margin-bottom: 8px;
`;

export const MappingStatRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 4px;
`;

export const MappingStatItem = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ $type, theme }) => {
    if ($type === 'success') return theme.colors.statusCompleted;
    if ($type === 'warning') return theme.colors.warningMessage;
    if ($type === 'error')   return theme.colors.statusFailed;
    return theme.colors.dark;
  }};
  white-space: nowrap;

  span {
    font-weight: 400;
    color: ${({ theme }) => theme.colors.tertiary};
    margin-left: 2px;
  }
`;

export const MappingStatDot = styled.span`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.borderLight};
  flex-shrink: 0;
`;

export const ConfirmedBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.successBg};
  border: 1px solid ${({ theme }) => theme.colors.successBorder};
  margin: 16px 0;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.statusCompleted};
  flex-shrink: 0;
`;

export const ModeBar = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0 0;
  flex-shrink: 0;
`;

export const HrisUploadRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
`;

export const HrisUploadMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const HrisUploadHint = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.tertiary};
`;

export const ColMapSection = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 10px 48px;
  display: flex;
  flex-direction: column;
`;

export const ColMapCard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  box-shadow: 0 1px 3px ${({ theme }) => theme.colors.cardShadow};
`;

export const ColMapCardFixed = styled.div`
  flex-shrink: 0;
  padding: 10px 24px 0;
  background: ${({ theme }) => theme.colors.white};
`;

export const ColMapCardBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 24px 8px;
`;

export const ColMapHeading = styled.p`
  margin: 0 0 3px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
  white-space: nowrap;
`;

export const ColMapSubtitle = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.tertiary};
`;

export const ColMapDivider = styled.div`
  font-size: 11px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.tertiary};
  text-transform: uppercase;
  letter-spacing: 0.6px;
  padding: 5px 8px;
  background: ${({ theme }) => theme.colors.light};
  border-radius: 4px;
  margin: ${({ $spaced }) => $spaced ? '24px' : '10px'} 0 6px;
`;

/* ── Legacy grid components (kept for reference, no longer rendered) ── */
export const ColMapGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 20px 1fr 20px 1fr;
  row-gap: 0;
`;

export const ColMapSeparator = styled.div`
  display: flex;
  justify-content: center;
  &::after { content: ''; width: 1px; background: ${({ theme }) => theme.colors.borderLight}; }
`;

export const ColMapRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  padding: 5px 0 5px 12px;
`;

export const ColMapLabel = styled.span`
  flex: 0 0 120px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dark};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ColMapArrow = styled.span`
  font-size: 6px;
  color: ${({ theme }) => theme.colors.borderLight};
  flex-shrink: 0;
  opacity: 0.4;
  margin: 0;
`;

export const ColMapSelectWrap = styled.div`
  flex: 1;
  min-width: 0;
  .ant-select { width: 100% !important; }
  .ant-select-selector { border-radius: 6px !important; font-size: 12px !important; }
`;

/* ── New vertical 3-column mapping layout ── */

export const OnboardingKeyHint = styled.div`
  flex: 1;
  min-width: 0;
  padding: 6px 12px;
  background: ${({ theme }) => theme.colors.secondary};
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 6px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OnboardingKeyField = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`;

export const ColMapTableHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0 7px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.borderLight};
  margin-top: 6px;
  background: ${({ theme }) => theme.colors.white};
`;

export const ColMapThField = styled.span`
  flex: 0 0 44%;
  padding-left: 46px;
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.dark};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ColMapThArrow = styled.span`
  flex: 0 0 56px;
`;

export const ColMapThFile = styled.span`
  flex: 1;
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.dark};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ColMapThStatus = styled.span`
  flex: 0 0 36px;
`;

export const ColMapGroupLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.dark};
  word-spacing: 4px;
  padding: 6px 24px 5px;
  margin: 8px -24px 2px;
  background: ${({ theme }) => theme.colors.secondary};
  border-left: 3px solid ${({ theme }) => theme.colors.primary};
`;

export const ColMapGroupDivider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors.borderLight};
  margin: 0 -24px;
`;

export const ColMapFieldRow = styled.div`
  display: flex;
  align-items: center;
  padding: 13px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
`;

export const ColMapFieldCell = styled.div`
  flex: 0 0 44%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  min-width: 0;
`;

export const ColMapArrowCol = styled.div`
  flex: 0 0 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ColMapFieldLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.dark};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
`;

export const ColMapFieldArrow = styled(ArrowRightOutlined)`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.dark};
`;

export const ColMapSelectCell = styled.div`
  flex: 1;
  min-width: 160px;
  max-width: 352px;
  padding-right: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .ant-select { width: 100% !important; }
  .ant-select-selector { border-radius: 6px !important; font-size: 12px !important; }
  .ant-select:not(.ant-select-disabled),
  .ant-select:not(.ant-select-disabled) * { cursor: pointer !important; }
`;

export const ColMapStatusCell = styled.div`
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ReqChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
`;

export const ReqChip = styled.button`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1.5px solid ${({ $selected, theme }) =>
    $selected ? theme.colors.primary : theme.colors.border};
  background: ${({ $selected, theme }) =>
    $selected ? theme.colors.secondary : theme.colors.white};
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.primary : theme.colors.dark};
  font-size: 11px;
  font-weight: ${({ $selected }) => ($selected ? 600 : 500)};
  cursor: pointer;
  max-width: 180px;
  transition: border-color 0.15s, background 0.15s, color 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ReqMoreChip = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 2px 9px;
  border-radius: 4px;
  border: 1.5px dashed ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.borderLight};
  background: ${({ $active, theme }) =>
    $active ? theme.colors.secondary : 'transparent'};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.tertiary};
  font-size: 11px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.15s, background 0.15s, color 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const NoMatchIcon = styled(InfoCircleOutlined)`
  color: ${({ theme }) => theme.colors.warningMessage};
  font-size: ${({ $size }) => $size || '15px'};
  cursor: pointer;
`;

export const ColMapFooter = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 24px 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
  background: ${({ theme }) => theme.colors.white};
`;

export const ColMapStatusPendingIcon = styled(QuestionCircleOutlined)`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.tertiary};
`;

export const ColMapStatusCheckIcon = styled(CheckCircleFilled)`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.statusCompleted};
`;

export const ColMapReqStar = styled.span`
  color: #ff4d4f;
  font-weight: 700;
  margin-left: 2px;
  font-size: 13px;
  line-height: 1;
`;

export const ColMapFullNameCheckRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 500;
`;

export const ColHeaderWrapper = styled.span`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const ColHeaderTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
`;

export const ColHeaderFilterSection = styled.span`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  padding-left: 12px;
  min-width: 0;
`;

export const ColHeaderFilterIcon = styled(FilterOutlined)`
  font-size: 11px;
  color: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.tertiary)};
`;

export const ColHeaderSelectWrap = styled.span`
  .ant-select {
    width: 128px !important;
  }
  .ant-select-selector {
    font-weight: normal !important;
  }
`;

/* ── Upload dragger (shown before file is selected) ── */

export const UploadCTASection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 48px 24px;
  overflow-y: auto;
`;

export const OnboardJourneyRow = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
  flex-shrink: 0;
`;

export const OnboardJourneyBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const OnboardJourneyStep = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

export const OnboardJourneyBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  background: ${({ $active, $done, theme }) =>
    $active || $done ? theme.colors.primary : theme.colors.borderLight};
  color: ${({ $active, $done, theme }) =>
    $active || $done ? (theme.colors.white ?? '#ffffff') : (theme.colors.tertiary ?? '#9CA3AF')};
`;

export const OnboardJourneyLabel = styled.span`
  display: inline-flex;
  align-items: baseline;
  font-size: 13px;
  font-weight: ${({ $active }) => $active ? 600 : 400};
  color: ${({ $active, $done, theme }) =>
    $active ? theme.colors.dark :
    $done ? theme.colors.primary : theme.colors.tertiary};
  white-space: nowrap;
`;

export const OnboardJourneyDivider = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.borderLight};
  flex-shrink: 0;
`;

export const HrisDraggerWrap = styled.div`
  max-width: 700px;
  width: 100%;
  align-self: center;

  .ant-upload-drag {
    min-height: 160px;
    border-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .ant-upload-btn {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 160px;
    padding: 16px 24px !important;
  }

  .ant-upload-drag-icon .anticon {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 25px !important;
  }

  .ant-upload-text {
    font-size: 15px !important;
    font-weight: 600 !important;
    color: ${({ theme }) => theme.colors.dark} !important;
    margin-bottom: 4px !important;
  }

  .ant-upload-hint {
    font-size: 12px !important;
    font-weight: 500 !important;
    color: ${({ theme }) => theme.colors.tertiary} !important;
    text-align: center !important;
    line-height: 1.5 !important;
  }
`;

export const EmpSearchWrapperStyled = styled.div`
  width: 460px;
  .ant-select {
    width: 100%;
  }
  .ant-select-clear {
    right: 44px;
  }
`;

/*
 * Scoped overrides for the View Employee table to match Jobs Library visual style.
 *
 * By default antd makes .ant-table-column-sorters flex: auto so it stretches to fill
 * the full column width, pushing the filter icon (⏚) to the far-right edge of the
 * header — far from the title text.  Jobs Library columns have no fixed widths, so
 * they auto-size to content and the icon ends up right next to the title.
 * Setting flex: none here replicates that tightness regardless of fixed column widths.
 */
export const EmpViewTableWrap = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;

  .ant-table table {
    min-width: max-content;
  }

  /* Sticky header via CSS — keeps header visible without AntD's separate
     header/body DOM split that causes horizontal scroll desync. */
  .ant-table-thead > tr > th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: ${p => p.theme?.colors?.tableHeaderBg ?? '#F1ECE3'} !important;
  }

  /* Compact cell font — wrapping is controlled per-column via fixed widths. */
  .ant-table-cell {
    font-size: 12px !important;
  }

  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.22);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.38);
  }

  .ant-table-column-has-filters .ant-table-column-sorters {
    flex: none;
  }
`;
